import { Component, Vue } from 'vue-property-decorator'
import QuestionBox from '../components/question'
import EmptyBox from '../components/empty-box'
import ActionBtns from '@/apps/h5/components/action-btns'
import { getQuestionTheSame, collectAction, cancelCollectAction } from '@/apps/h5/model/api'
const category = 2
@Component({ components: { QuestionBox, EmptyBox, ActionBtns } })
export default class QuestionTheSame extends Vue {

    // data
    public questionList: any[] = []
    public idx = Number(this.$route.query.idx) || 0
    public token = ''
    public showAnalysis = false
    public id = ''

    //computed
    public get question (): any {
        return this.questionList && this.questionList.length > 0 ? this.questionList[this.idx] : null
    }
    public get isCollected() {
        return this.question.is_collected
    }
    public get subject() {
        return this.question.subject_id
    }

    //methods
    public async renderList() {
        try {
            const { data, success }: any = await getQuestionTheSame({ question_id: this.id, question_ids: [] }, {
                token: this.token
            })
            if (success) {
                const { questions } = data
                this.questionList = questions
            }
        } catch(e) {
            
        }
        
    }
    public handleClkQuestionNum(index) {
        this.idx = index
    }
    public clickShowAnalysis() {
        this.showAnalysis = !this.showAnalysis
    }
    // 收藏
    public async handleCollect(val) {
        if (val) {
            try {
                const { data, success }: any = await cancelCollectAction({
                    category,
                    doc_id: Number(this.question.id),
                    subject_id: this.subject
                }, {token: this.token})
                if (success) {
                    this.questionList[this.idx].is_collected = !val
                    this.$message.success('取消收藏')
                }
            } catch(e) {
                console.log(e)
            }
        } else {
            try {
                const { data, success }: any = await collectAction({
                    category,
                    doc_id: Number(this.question.id),
                    subject_id: this.subject
                }, {token: this.token})
                if (success) {
                    this.questionList[this.idx].is_collected = !val
                    this.$message.success('收藏成功')
                }
            } catch(e) {
                console.log(e)
            }
        }
    }

    // mounted
    public mounted() {
        const route = this.$route
        const { id, token }: any = this.$route.query
        this.id = id
        this.token = token
        this.renderList()
        const uni = (window as any).uni
        const { path,   } = route
        document.addEventListener('UniAppJSBridgeReady', () => {
            uni.postMessage({
                data: {
                    action: 'message',
                    path,
                    id,
                    idx: this.idx
                }
            })
        })
    }
}

